<template>
    <v-card width="400" class="mx-auto ma-4">
        <v-card-title>
            Inga stationer
        </v-card-title>
        <v-card-text>
            Du är inte tillagd på någon station. Be stationsadministratören att lägga till dig för att använda systemet.
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "NoStation",
}
</script>

<style>

</style>